import React from "react";
import "./styles/PricingPage.css";
import { Link } from "react-router-dom";

const PricingPage = () => {
  return (
    <div className="pricing-page">
      <h1 className="pricing-title">Unlock your music's full reach with powerful fan outreach plans</h1>
      <p className="pricing-subtitle">Plans for every musician, creator, and team. Scale your reach at your own pace.</p>

      <div className="pricing-cards four-column wider">
        {/* Pay-as-you-go: Global Fans */}
        <div className="card">
          <h2>Pay-as-you-go: Global Fans</h2>
          <p className="price">£10<span>/campaign</span></p>
          <ul className="feature-list">
            <li>1 campaign per payment</li>
            <li>Reach up to 1,000 fans</li>
            <li>Target users of a specific hashtag</li>
            <li>Fans can be from any country</li>
            <li>Great for global exposure and testing new ideas</li>
          </ul>
          <Link to="/signup" className="button-primary">Get Started</Link>
        </div>

        {/* Pay-as-you-go: National Fans */}
        <div className="card">
          <h2>Pay-as-you-go: National Fans</h2>
          <p className="price">£15<span>/campaign</span></p>
          <ul className="feature-list">
            <li>1 campaign per payment</li>
            <li>Reach up to 1,000 fans</li>
            <li>Target users of a specific hashtag</li>
            <li>Limit targeting to one country only</li>
            <li>Ideal for national tours or localized promotions</li>
          </ul>
          <Link to="/signup" className="button-primary">Get Started</Link>
        </div>

        {/* Unlimited Creator Plan */}
        <div className="card recommended">
          <div className="badge">Recommended</div>
          <h2>Unlimited Creator Plan</h2>
          <p className="price">£299<span>/month</span></p>
          <ul className="feature-list">
            <li>100 campaigns/month</li>
            <li>Target across multiple hashtags & countries</li>
            <li>No per-campaign limits</li>
            <li>Great for fanbase growth at scale</li>
            <li>Ideal for artists running regular outreach</li>
          </ul>
          <Link to="/signup" className="button-primary">Get Started</Link>
        </div>

        {/* Agency Plan */}
        <div className="card">
          <h2>Agency Plan</h2>
          <p className="price">Starts £599<span>/month</span></p>
          <ul className="feature-list">
            <li>150+ campaigns/month</li>
            <li>Designed for high-volume outreach</li>
            <li>Full control, support, and scalability</li>
            <li>Best for teams, managers, and record labels</li>
            <li>Includes advanced targeting, analytics & multi-user access</li>
          </ul>
          <Link to="/signup" className="button-primary">Get Started</Link>
        </div>
      </div>
    </div>
  );
};

export default PricingPage;